// @ts-strict-ignore
import { DeviceUtils } from './device-utils';

export class EventUtils {
  private static beforeUnloadHandler;

  // do not show alert in regard to leaving page
  public static resetBeforeUnload(): void {
    if (DeviceUtils.isIos()) {
      EventUtils.beforeUnloadHandler = window.onpagehide;
      window.onpagehide = null;
    } else {
      EventUtils.beforeUnloadHandler = window.onbeforeunload;
      window.onbeforeunload = null;
    }
  }

  // restore alert in regard to leaving page
  public static restoreBeforeUnload(): void {
    if (DeviceUtils.isIos()) {
      window.onpagehide = EventUtils.beforeUnloadHandler;
    } else {
      window.onbeforeunload = EventUtils.beforeUnloadHandler;
    }
  }
}
